import { render, staticRenderFns } from "./attribute.vue?vue&type=template&id=670b1ba0&scoped=true&"
import script from "./attribute.vue?vue&type=script&lang=js&"
export * from "./attribute.vue?vue&type=script&lang=js&"
import style0 from "./attribute.vue?vue&type=style&index=0&id=670b1ba0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670b1ba0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('670b1ba0')) {
      api.createRecord('670b1ba0', component.options)
    } else {
      api.reload('670b1ba0', component.options)
    }
    module.hot.accept("./attribute.vue?vue&type=template&id=670b1ba0&scoped=true&", function () {
      api.rerender('670b1ba0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/blindBox/attribute.vue"
export default component.exports